<div class="p-grid">
	<div class="p-col-12 button-container">
		<button pButton type="button" label="{{ 'button.denial' | translate }}"
				class="button" routerLink="/denial"
		></button>
	</div>
</div>

